import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert } from "lucide-react";

const PARAGRAPHS = [
  `All content generated is provided solely for educational and informational purposes. The user assumes full responsibility for any actions taken based on this information. Any workout plans, exercise recommendations, fitness guidance, nutritional suggestions, meal plans, or lifestyle advice are not medical advice and should not be considered a substitute for consultation with qualified healthcare, medical, nutritional, or fitness professionals.`,
  `The creator, website, company, affiliates, employees, contractors, and licensors assume no liability whatsoever for any injury, illness, damages, losses, adverse health outcomes, or claims arising from the use of this content. Participation in any fitness or nutrition program is entirely voluntary and at the user's own risk.`,
  `Any names, characters, artwork, logos, designs, likenesses, themes, or concepts that may appear similar to existing copyrighted, trademarked, fictional, or real-world properties are purely coincidental and are not intended to infringe upon or replicate any intellectual property rights. No affiliation, endorsement, sponsorship, or ownership by any third party is implied.`,
  `All content is provided "AS IS" without warranties of any kind, express or implied. Users are solely responsible for verifying compliance with applicable laws, regulations, intellectual property rights, and platform requirements. By accessing or using this content, the user agrees to release, indemnify, defend, and hold harmless the creator, website, company, affiliates, employees, contractors, and licensors from any and all claims, liabilities, damages, losses, costs, or expenses arising from the use of the content.`,
];

export default function Legal() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-10 py-16" data-testid="legal-page">
      <div className="flex items-center gap-3 mb-3">
        <ShieldAlert className="w-5 h-5 text-[#FF3333]" />
        <div className="font-mono text-[10px] tracking-[0.4em] text-[#FF3333]">LEGAL NOTICE · USE AT YOUR OWN RISK</div>
      </div>
      <h1 className="font-heading uppercase text-5xl md:text-6xl leading-[0.9]">
        Disclaimer &amp; <br /><span className="text-stroke">Liability Release</span>
      </h1>
      <p className="font-sub text-white/60 mt-4">
        Last updated: {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}.
      </p>

      <div className="brutal-border-red bg-[#FF3333]/5 p-5 mt-8 flex items-start gap-3" data-testid="legal-banner">
        <AlertTriangle className="w-5 h-5 text-[#FF3333] flex-shrink-0 mt-0.5" />
        <div className="font-sub text-white/90 text-sm leading-relaxed">
          <strong className="text-[#FF3333]">READ IN FULL.</strong> By accessing this website, creating an account, generating an AI plan, chatting with FORGE-AI, logging workouts or food, subscribing to the newsletter, or purchasing merchandise, you confirm that you have read, understood, and agreed to the disclaimer below in its entirety.
        </div>
      </div>

      <div className="mt-10 space-y-6">
        {PARAGRAPHS.map((p, i) => (
          <p
            key={i}
            data-testid={`legal-paragraph-${i}`}
            className="font-sub text-white/80 leading-relaxed text-[15px]"
          >
            {p}
          </p>
        ))}
      </div>

      <div className="brutal-border bg-[#0a0a0a] mt-16 p-6 text-center">
        <div className="font-mono text-[10px] tracking-widest text-white/40 mb-3">CONTACT</div>
        <div className="font-sub text-white/80">
          For legal, DMCA, or privacy questions: <br />
          <a href="mailto:legal@forgedathletics.fit" className="text-[#FF3333] hover:underline">legal@forgedathletics.fit</a>
        </div>
        <Link to="/" className="btn-forged-ghost mt-6 inline-flex">← Back home</Link>
      </div>
    </div>
  );
}
